// modiles
import Vue from 'vue';
import Vuex from 'vuex';
import axiosRetry from 'axios-retry';
import destr from 'destr'
import {
  browserName,
  browserVersion,
  deviceDetect,
} from 'mobile-device-detect';
import DeviceDetector from 'device-detector-js';
import VuexPersistence from 'vuex-persist'

// axios
import axios from '@/axios';

// modules
import modules from './modules';

// localstorage
import LocalStorageService from '@/localStorage';

// utils
import cookies from '@/utils/cookies';

// constants
import { COOKIES } from '@/constants';

// services
const localStorageService = LocalStorageService.getService();

const vuexLocal = new VuexPersistence({
  key: 'w-globals',
  storage: window.localStorage,
  modules: ['global']
})

Vue.use(Vuex);

axiosRetry(axios, {
  retries: 1,
  shouldResetTimeout: true,
  retryCondition: () => true,
  retryDelay: retryCount => {
    return retryCount * 3000;
  },
});

export default new Vuex.Store({
  state: {
    website: process.env.VUE_APP_WEBSITE_URL,
    errorlog: process.env.VUE_APP_ERROR_LOG_URL,
  },
  mutations: {},
  actions: {
    async getExperimentAnalyticsDetails(context) {
      const flowVariant = cookies.get('flowVariant') || context.rootState.onboarding.onboardingPatient?.flow_variant || null;
      return { flowVariant };
    },
    async getEverflowDetails() {
      if (typeof EF != 'undefined') {
        const transactionId = EF.getAdvertiserTransactionId(1);
        if (EF && transactionId) {
          return {
            type: 'everflow',
            id: transactionId,
          };
        } else {
          return {};
        }
      }
    },
    async getDeduplicationID(context) {
      const deduplicationID = context.rootState.onboarding.onboardingPatient?.deduplicationID || cookies.get('winona_deduplicationID')
      return deduplicationID
    },
    async getImpactId() {
      const impactId = cookies.get('irclickid');
      if (impactId) {
        return {
          type: 'impactRadius',
          id: impactId,
        }
      } else {
        return {};
      }
    },
    async getUTMProperties() {
      let campaign = undefined;
      const winonaUtms = destr(cookies.get('winona_utms')) || undefined;

      if (
        winonaUtms != undefined &&
        winonaUtms.constructor.name === 'Object'
      ) {
        const utmName = winonaUtms.utm_name || winonaUtms.utm_campaign || undefined;
        const utmSource = winonaUtms.utm_source || undefined;
        const utmMedium = winonaUtms.utm_medium || undefined;
        const utmCampaign = winonaUtms.utm_campaign || undefined;
        const utmTerm = winonaUtms.utm_term || undefined;
        const utmContent = winonaUtms.utm_content || undefined;
        const utmAudience = winonaUtms.utm_audience || undefined;
        const utmSite = winonaUtms.utm_site || undefined;
        const utmPlacement = winonaUtms.utm_placement || undefined;

        if (
          utmName != undefined ||
          utmSource != undefined ||
          utmMedium != undefined ||
          utmCampaign != undefined ||
          utmTerm != undefined ||
          utmContent != undefined ||
          utmAudience != undefined ||
          utmSite != undefined ||
          utmPlacement != undefined
        ) {
          campaign = {
            name: utmName,
            source: utmSource,
            medium: utmMedium,
            campaign: utmCampaign,
            term: utmTerm,
            content: utmContent,
            audience: utmAudience,
            site: utmSite,
            placement: utmPlacement,
          };
        }
      }

      return campaign;
    },
    async getFTUTMProperties() {
      let ftcampaign = undefined;
      const winonaFirstTouchUtms = destr(cookies.get('winona_firsttouch_utms')) || undefined;

      if (
        winonaFirstTouchUtms != undefined &&
        winonaFirstTouchUtms.constructor.name === 'Object'
      ) {
        const ftUtmName = winonaFirstTouchUtms.utm_name || undefined;
        const ftUtmSource = winonaFirstTouchUtms.utm_source || undefined;
        const ftUtmMedium = winonaFirstTouchUtms.utm_medium || undefined;
        const ftUtmCampaign = winonaFirstTouchUtms.utm_campaign || undefined;
        const ftUtmTerm = winonaFirstTouchUtms.utm_term || undefined;
        const ftUtmContent = winonaFirstTouchUtms.utm_content || undefined;
        const fUtmAudience = winonaFirstTouchUtms.utm_audience || undefined;
        const fUtmSite = winonaFirstTouchUtms.utm_site || undefined;
        const fUtmPlacement = winonaFirstTouchUtms.utm_placement || undefined;

        if (
          ftUtmName != undefined ||
          ftUtmSource != undefined ||
          ftUtmMedium != undefined ||
          ftUtmCampaign != undefined ||
          ftUtmTerm != undefined ||
          ftUtmContent != undefined ||
          fUtmAudience != undefined ||
          fUtmSite != undefined ||
          fUtmPlacement != undefined
        ) {
          ftcampaign = {
            firsttouch_name: ftUtmName,
            firsttouch_source: ftUtmSource,
            firsttouch_medium: ftUtmMedium,
            firsttouch_campaign: ftUtmCampaign,
            firsttouch_term: ftUtmTerm,
            firsttouch_content: ftUtmContent,
            firsttouch_audience: fUtmAudience,
            firsttouch_site: fUtmSite,
            firsttouch_placement: fUtmPlacement,
          };
        }
      }

      return ftcampaign
    },
    async sendErrorLog(state, data) {
      if (data.error_log.status == 400) {
        return
      }

      const errorDetails =
        data.error_log.status == 500
          ? `Server error -- Log ID: ${data.error_log.logid}`
          : data.error_log.message;

      const cusId = data?.cus_id ? data.cus_id : 'No ID (Unregistered)';
      const email = data?.email ? data.email : 'No Email (Unregistered)';

      const currentDate = new Date();

      const eventObject = {
        event: 'ONBOARDING_ERROR',
        created_at: currentDate,
        referring_step: data.step,
        customerid: cusId,
        email: email,
        error_log: errorDetails,
        environment: process.env.VUE_APP_SERVER,
      };

      if (process.env.VUE_APP_SERVER == 'local') {
        eventObject.environment = 'STAGING';
      }
      const requestOptions = {
        method: 'post',
        url: process.env.VUE_APP_ERROR_LOG_URL,
        data: eventObject,
      };

      if (typeof errorDetails == 'String') {
        eventObject.error_log = {
          id: 'clientside_error',
          message: errorDetails,
        };
      }

      // * Comment this out before deploying-- This is for testing only
      console.log(eventObject);

      try {
        await axios.request(requestOptions);
      } catch (err) {
        console.error(err);
      }
    },
    async getFBQParams() {
      const fbParams = {};
      try {
        const fbp = await cookies.get('_fbp');
        const fbc = await cookies.get('_fbc');
        if (fbp) {
          fbParams.fbp = fbp;
        }
        if (fbc) {
          fbParams.fbc = fbc;
        }
      } catch (err) {
        console.log(err)
      }
      return fbParams;
    },
    async getTbclid() {
      const tbclid = cookies.get('winona_tbclid');
      if (tbclid) {
        return tbclid;
      }
    },
    async getVoluumDetails() {
      // Set to store function in case more details are needed/set to a separate property
      const clickid = cookies.get('taboolaClickID');
      const ret = {};
      if (clickid) {
        ret.clickID = clickid.taboolaClickID;
      }
      return ret;
    },
    async getDeviceDetails() {
      try {
        const detect = deviceDetect();
        let device = 'Desktop';
        if (detect.isMobileOnly != undefined && detect.isMobileOnly === true) {
          device = 'Mobile';
        } else if (detect.isTablet != undefined && detect.isTablet === true) {
          device = 'Tablet';
        } else if (detect.isMobile != undefined && detect.isMobile === true) {
          device = 'Mobile';
        } else if (detect.isSmartTV != undefined && detect.isSmartTV === true) {
          device = 'SmartTV';
        } else if (
          detect.isWearable != undefined &&
          detect.isWearable === true
        ) {
          device = 'Wearable';
        }

        const deviceDetector = new DeviceDetector();
        const detectedDevice = deviceDetector.parse(navigator.userAgent);

        const hardwareModel = `${detectedDevice.device.brand} ${detectedDevice.device.model}`;

        let campaign = undefined;
        const winonaUtms = destr(cookies.get('winona_utms')) || undefined;

        if (
          winonaUtms != undefined &&
          winonaUtms.constructor.name === 'Object'
        ) {
          const utmName = winonaUtms.utm_name || winonaUtms.utm_campaign || undefined;
          const utmSource = winonaUtms.utm_source || undefined;
          const utmMedium = winonaUtms.utm_medium || undefined;
          const utmCampaign = winonaUtms.utm_campaign || undefined;
          const utmTerm = winonaUtms.utm_term || undefined;
          const utmContent = winonaUtms.utm_content || undefined;

          if (
            utmName != undefined ||
            utmSource != undefined ||
            utmMedium != undefined ||
            utmCampaign != undefined ||
            utmTerm != undefined ||
            utmContent != undefined
          ) {
            campaign = {
              name: utmName,
              source: utmSource,
              medium: utmMedium,
              campaign: utmCampaign,
              term: utmTerm,
              content: utmContent,
            };
          }
        }

        let firsttouchcampaign = undefined;
        const winonaFirstTouchUtms = destr(cookies.get('winona_firsttouch_utms')) || undefined;

        if (
          winonaFirstTouchUtms != undefined &&
          winonaFirstTouchUtms.constructor.name === 'Object'
        ) {
          const utmName = winonaFirstTouchUtms.utm_name || undefined;
          const utmSource = winonaFirstTouchUtms.utm_source || undefined;
          const utmMedium = winonaFirstTouchUtms.utm_medium || undefined;
          const utmCampaign = winonaFirstTouchUtms.utm_campaign || undefined;
          const utmTerm = winonaFirstTouchUtms.utm_term || undefined;
          const utmContent = winonaFirstTouchUtms.utm_content || undefined;

          if (
            utmName != undefined ||
            utmSource != undefined ||
            utmMedium != undefined ||
            utmCampaign != undefined ||
            utmTerm != undefined ||
            utmContent != undefined
          ) {
            firsttouchcampaign = {
              name: utmName,
              source: utmSource,
              medium: utmMedium,
              campaign: utmCampaign,
              term: utmTerm,
              content: utmContent,
            };
          }
        }

        const ret = {
          browser: browserName,
          browserVersion: browserVersion,
          os: detect.osName != undefined ? detect.osName : detect.os,
          os_version: detect.osVersion,
          device: device,
          campaign: campaign,
          firsttouchcampaign: firsttouchcampaign,
        };

        if (device != 'Desktop') {
          ret.hardwareModel = hardwareModel;
        }

        return ret;
      } catch (err) {
        console.log(err);
      }
    },

    async getGclidDetails() {
      const gclid = cookies.get('winona_gclid');
      const ret = {};
      if (gclid) {
        ret.gclid = gclid;
      }
      return ret;
    },

    async getTtclidDetails() {
      const ttclid = cookies.get('winona_ttclid');
      const ret = {};
      if (ttclid) {
        ret.ttclid = ttclid;
      }
      return ret;
    },

    async getDeviceDetailsForContext() {
      try {
        const detect = deviceDetect();
        let device = 'Desktop';
        if (detect.isMobileOnly != undefined && detect.isMobileOnly === true) {
          device = 'Mobile';
        } else if (detect.isTablet != undefined && detect.isTablet === true) {
          device = 'Tablet';
        } else if (detect.isMobile != undefined && detect.isMobile === true) {
          device = 'Mobile';
        } else if (detect.isSmartTV != undefined && detect.isSmartTV === true) {
          device = 'SmartTV';
        } else if (
          detect.isWearable != undefined &&
          detect.isWearable === true
        ) {
          device = 'Wearable';
        }

        const ret = {
          browserVersion: browserVersion,
          browser: browserName,
          device: device,
        };

        const winonaUtms = destr(cookies.get('winona_utms')) || undefined;
        let winonaFirstTouchUtms = destr(cookies.get('winona_firsttouch_utms')) || undefined;

        if (winonaUtms === undefined || winonaFirstTouchUtms === undefined) {
          const nobackendutm = cookies.get('nobackendutm') || undefined;
          const nobackendfirsttouchutm = cookies.get('nobackendfirsttouchutm') || undefined;

          if (
            nobackendutm === undefined ||
            nobackendfirsttouchutm === undefined
          ) {
            const sessioncookies = await this.dispatch('getSessionCookies');

            const UTM_KEY_MAP = {
              campaignid: 'utm_id',
              name: 'utm_name',
              content: 'utm_content',
              campaign: 'utm_campaign',
              source: 'utm_source',
              medium: 'utm_medium',
              term: 'utm_term',
              site: 'utm_site',
              audience: 'utm_audience',
              placement: 'utm_placement',
            };

            const parsedutm = {};
            const parsedftutm = {};
            Object.entries(sessioncookies || {}).forEach(([key, value]) => {
              if (!value) {
                return;
              }

              if (key.startsWith('firsttouch-utm-')) {
                const mapped = UTM_KEY_MAP[key.replace('firsttouch-utm-', '')];
                if (mapped) {
                  parsedftutm[mapped] = value;
                }
              } else if (key.startsWith('utm-')) {
                const mapped = UTM_KEY_MAP[key.replace('utm-', '')];
                if (mapped) {
                  parsedutm[mapped] = value;
                }
              }
            });

            if (
              Object.keys(parsedutm).length > 0 ||
              Object.keys(parsedftutm).length > 0
            ) {
              const strCookie = JSON.stringify(parsedutm);
              cookies.set(COOKIES.TRACKING.MARKETING_UTMS.NAME, strCookie, COOKIES.TRACKING.MARKETING_UTMS.TTL, null, COOKIES.COOKIE_DOMAIN);

              const strCookieFirstTouch = JSON.stringify(parsedftutm);
              cookies.set(COOKIES.TRACKING.FIRST_TOUCH_UTMS.NAME, strCookieFirstTouch, COOKIES.TRACKING.FIRST_TOUCH_UTMS.TTL, null, COOKIES.COOKIE_DOMAIN);
              winonaFirstTouchUtms = parsedftutm;
            } else {
              cookies.set('nobackendutm', true, '1h');
              cookies.set('nobackendfirsttouchutm', true, '1h');

              if (
                winonaFirstTouchUtms === undefined &&
                winonaUtms != undefined
              ) {
                winonaFirstTouchUtms = winonaUtms;
                const strCookieFirstTouch = JSON.stringify(winonaUtms);
                cookies.set(COOKIES.TRACKING.FIRST_TOUCH_UTMS.NAME, strCookieFirstTouch, COOKIES.TRACKING.FIRST_TOUCH_UTMS.TTL, null, COOKIES.COOKIE_DOMAIN);
              }
            }
          }
        }

        if (
          winonaUtms != undefined &&
          winonaUtms.constructor.name === 'Object'
        ) {
          const utmSource = winonaUtms.utm_source || undefined;
          const utmMedium = winonaUtms.utm_medium || undefined;
          const utmCampaign = winonaUtms.utm_campaign || undefined;
          const utmTerm = winonaUtms.utm_term || undefined;
          const utmContent = winonaUtms.utm_content || undefined;
          let campaignId = Number(winonaUtms.utm_id) || undefined;

          if (campaignId && isNaN(campaignId)) {
            campaignId = undefined;
          }

          if (utmSource != undefined) {
            ret['sessionUTMSource'] = utmSource;
          }
          if (utmMedium != undefined) {
            ret['sessionUTMMedium'] = utmMedium;
          }
          if (utmCampaign != undefined) {
            ret['sessionUTMCampaign'] = utmCampaign;
          }
          if (utmTerm != undefined) {
            ret['sessionUTMTerm'] = utmTerm;
          }
          if (utmContent != undefined) {
            ret['sessionUTMContent'] = utmContent;
          }
          if (campaignId != undefined) {
            ret['campaignId'] = campaignId;
          }
        }

        if (
          winonaFirstTouchUtms != undefined &&
          winonaFirstTouchUtms.constructor.name === 'Object'
        ) {
          const utmSource = winonaFirstTouchUtms.utm_source || undefined;
          const utmMedium = winonaFirstTouchUtms.utm_medium || undefined;
          const utmCampaign = winonaFirstTouchUtms.utm_campaign || undefined;
          const utmTerm = winonaFirstTouchUtms.utm_term || undefined;
          const utmContent = winonaFirstTouchUtms.utm_content || undefined;

          if (utmSource != undefined) {
            ret['firsttouchUTMSource'] = utmSource;
          }
          if (utmMedium != undefined) {
            ret['firsttouchUTMMedium'] = utmMedium;
          }
          if (utmCampaign != undefined) {
            ret['firsttouchUTMCampaign'] = utmCampaign;
          }
          if (utmTerm != undefined) {
            ret['firsttouchUTMTerm'] = utmTerm;
          }
          if (utmContent != undefined) {
            ret['firsttouchUTMContent'] = utmContent;
          }
        }

        ret.os = detect.osName != undefined ? detect.osName : detect.os;
        ret.os_version = detect.osVersion;

        const deviceDetector = new DeviceDetector();
        const detectedDevice = deviceDetector.parse(navigator.userAgent);

        const hardwareModel = `${detectedDevice.device.brand} ${detectedDevice.device.model}`;
        if (device != 'Desktop') {
          ret.hardwareModel = hardwareModel;
        }

        return ret;
      } catch (err) {
        console.log(err);
      }
    },

    async setUTMS(context, query) {
      const cookie = {};

      console.log('query', query)

      if (query.utm_name != undefined) {
        cookie.utm_name = query.utm_name;
      }

      if (query.utm_source != undefined) {
        cookie.utm_source = query.utm_source;
      }

      if (query.utm_medium != undefined) {
        cookie.utm_medium = query.utm_medium;
      }

      if (query.utm_campaign != undefined) {
        cookie.utm_campaign = query.utm_campaign;
      }

      if (query.utm_term != undefined) {
        cookie.utm_term = query.utm_term;
      }

      if (query.utm_content != undefined) {
        cookie.utm_content = query.utm_content;
      }

      if (query.utm_placement != undefined) {
        cookie.utm_placement = query.utm_placement;
      }

      if (query.utm_audience != undefined) {
        cookie.utm_audience = query.utm_audience;
      }

      if (query.utm_site != undefined) {
        cookie.utm_site = query.utm_site;
      }

      if (query.campaignId != undefined) {
        cookie.utm_id = query.campaignId;
      }

      if (query.campaignID != undefined) {
        cookie.utm_id = query.campaignID;
      }

      if (
        query[COOKIES.SHOW_PROMO_FORM.KEY] === COOKIES.SHOW_PROMO_FORM.VALUE
      ) {
        cookies.set(
          COOKIES.SHOW_PROMO_FORM.COOKIE_NAME,
          true,
          COOKIES.SHOW_PROMO_FORM.COOKIE_DURATION
        );
      }

      if (Object.keys(cookie).length > 0) {
        const strCookies = JSON.stringify(cookie);
        cookies.set(COOKIES.TRACKING.MARKETING_UTMS.NAME, strCookies, COOKIES.TRACKING.MARKETING_UTMS.TTL, null, COOKIES.COOKIE_DOMAIN);
        /**
         * First-touch UTMs are write-once: set only when absent, never overwritten until the cookie expires (TTL).
         */
        const firsttouch = cookies.get(COOKIES.TRACKING.FIRST_TOUCH_UTMS.NAME);
        if (!firsttouch) {
          cookies.set(
            COOKIES.TRACKING.FIRST_TOUCH_UTMS.NAME,
            strCookies,
            COOKIES.TRACKING.FIRST_TOUCH_UTMS.TTL,
            null,
            COOKIES.COOKIE_DOMAIN
          );
        }
      }
    },

    // login to WINONA
    login(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'post',
          url: 'signin',
          data: data,
          headers: {
            'Content-Type': 'application/json',
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            localStorageService.setToken(response.data.body.idToken);
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            return reject(error);
          });
      });
    },

    getUser(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'get',
          url: 'user',
          data: data,
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
        };
        axios(options)
          .then(function (response) {
            // console.log(response.data)
            // if (response?.data?.message && response.data.message !== "success") return reject(response.data)
            localStorageService.setuserID(response.data.body.id);
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            return reject(error);
          });
      });
    },

    // first step signup for new user
    signup(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'post',
          url: 'signup',
          data: data,
          headers: {
            'Content-Type': 'application/json',
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            localStorageService.setToken(response.data.body.idToken);
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error.response.data);
            console.log(error);
            return reject(error);
          });
      });
    },

    // check status for wizard form
    getBoardingStatus(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'get',
          url: 'onboarding',
          data: data,
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
        };
        axios(options)
          .then(function (response) {
            // console.log(response.data)
            // if (response?.data?.message && response.data.message !== "success") return reject(response.data)
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            return reject(error);
          });
      });
    },
    // fill up basic information
    // update user
    updateUser(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'put',
          url: 'user',
          data: data,
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
          validateStatus: () => {
            return true; // I'm always returning true, you may want to do it depending on the status received
          },
        };
        axios(options)
          .then(function (response) {
            // console.log(response.data.body)
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            return reject(error);
          });
      });
    },

    // upload avatar
    uploadImage(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'post',
          url: 'user/avatar',
          data: data,
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
            'Content-Type': 'multipart/form-data',
          },
          validateStatus: () => {
            return true; // I'm always returning true, you may want to do it depending on the status received
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            return reject(error);
          });
      });
    },

    // shipping details
    addShippingDetails(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'post',
          url: 'shipping',
          data: data,
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
          validateStatus: () => {
            return true; // I'm always returning true, you may want to do it depending on the status received
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            return resolve(response.data);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            console.log(error);
            return reject(error);
          });
      });
    },

    getShippingDetails(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'get',
          url: 'shipping',
          data: data,
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            return reject(error);
          });
      });
    },

    // credit card details
    addCardDetails(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'post',
          url: 'payment',
          data: data,
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            return resolve(response.data);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            console.log(error);
            return reject(error);
          });
      });
    },

    getCardDetails(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'get',
          url: 'payment',
          data: data,
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            return resolve(response.data);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            console.log(error);
            return reject(error);
          });
      });
    },

    logout() {
      return new Promise((resolve, reject) => {
        axios
          .post(
            'signout',
            {
              /* body */
            },
            {
              headers: {
                Authorization: `Bearer ${localStorageService.getAccessToken()}`,
              },
            }
          )
          .then(function (response) {
            localStorageService.clearToken();
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            return reject(error);
          });
      });
    },

    //JAMES
    async getConversation() {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'get',
          url: 'conversation',
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            return reject(error);
          });
      });
    },

    async getConversationMember(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'get',
          url: `conversation/${data.id}/member`,
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            return reject(error);
          });
      });
    },

    async getConversationMessage(context, data) {
      return new Promise((resolve, reject) => {
        const options = {
          method: 'get',
          url: `conversation/${data.id}/message?nextpage=${data.nextPage}`,
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            return reject(error);
          });
      });
    },

    async sendMessage(context, data) {
      return new Promise((resolve, reject) => {
        const conversationid = data.id;
        delete data['id'];
        const options = {
          method: 'post',
          url: `conversation/${conversationid}/message`,
          data: data,
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            return resolve(response.data.body);
          })
          .catch(function (error) {
            if (error?.response?.data?.message)
              return reject(error?.response?.data);
            return reject(error);
          });
      });
    },

    async getSessionCookies() {
      return new Promise((resolve, reject) => {
        const options = {
          baseURL: process.env.VUE_APP_ONBOARDING_API_URL,
          method: 'get',
          url: 'session/cookies',
          headers: {
            Authorization: `Bearer ${localStorageService.getAccessToken()}`,
          },
        };
        axios(options)
          .then(function (response) {
            if (response?.data?.message && response.data.message !== 'success')
              return reject(response.data);
            return resolve(response.data.body);
          })
          .catch(function () {
            return resolve({});
          });
      });
    },
  },
  modules,
  plugins: [vuexLocal.plugin]
});
